import { writable, derived } from "svelte/store";
import config from "./config";

export const windowWidth = writable(window.innerWidth);
export const windowHeight = writable(window.innerHeight);

export const isMobile = derived(windowWidth,
    $windowWidth => $windowWidth < 768 ? true : false
)

export const isLarge = derived(windowWidth,
    $windowWidth => $windowWidth > 1400 ? true : false
)

export const isPortrait = writable(window.matchMedia("(orientation: portrait)").matches);
export const isSafari = writable(window.safari !== undefined);

export const selectedType = writable(null);

export const showAllTitles = writable(true);
export const keyIsExpanded = writable(false);

export const currentYear = writable(null);
export const allYears = writable([]);

// USER ONBOARDING
const userHasOnboarded = localStorage.getItem("onboarded");
export const onboarded = writable(userHasOnboarded || 'no'); // We can only store strings as values in local storage, not booleans

// On change of onboarded, save to local storage
onboarded.subscribe(value => {
    localStorage.setItem("onboarded", value === "yes" ? "yes" : "no");
});

// MODAL HANDLING
export const modalActive = writable(false);

// ICON SIZE
export const iconSizeLookup = derived([windowWidth, windowHeight],
    ([$windowWidth, $windowHeight]) =>
        $windowHeight < 400 || $windowWidth < 400 ? config.tinySizeLookup
        :  $windowHeight < 567 || $windowWidth < 768 ? config.mobileSizeLookup
        : config.desktopSizeLookup
)